//create a react functional component in typescript
import { useEffect, useState, type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import User from './user';

interface userListProps {
  refreshCounter: number;
}

const UserList: FC<userListProps> = ({ refreshCounter }) => {
  const [users, setUsers] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);

  const getUsers = async () => {
    setLoading(true);

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const storedJWT = localStorage.getItem('jwt');

    user.email &&
      (await fetch(process.env.REACT_APP_API_URL + '/get-users.php', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + storedJWT,
        },
        body: JSON.stringify({
          email: user.email,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setUsers(data);
          setLoading(false);
        })
        .catch((error) => {
          // Handle network or server errors
          console.log('error');
          console.log(error);
          setLoading(false);
        }));
  };

  //create the function to create a folder

  useEffect(() => {
    getUsers();
  }, [refreshCounter]);

  return (
    <div className="min-h-[300px] py-5 md:py-10  pr-3 max-w-full overflow-x-hidden relative mb-10 md:mb-0">
      {loading ? (
        <div className="flex justify-center">
          <svg
            className="inline-blockmt-5 w-9 h-9 text-accent animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
      ) : (
        <div className="max-h-[60vh] max-w-full relative overflow-x-scroll border-b border-slate-100 pb-5">
          <div className="grid grid-cols-7 min-w-[800px]">
            <div>
              <p className="px-3 py-2 text-xs font-bold uppercase border-b border-r border-gray-200">
                Lastname
              </p>
            </div>
            <div>
              <p className="px-3 py-2 text-xs font-bold uppercase border-b border-r border-gray-200">
                Firstname
              </p>
            </div>
            <div>
              <p className="px-3 py-2 text-xs font-bold uppercase border-b border-r border-gray-200">
                Roles
              </p>
            </div>
            <div>
              <p className="px-3 py-2 text-xs font-bold uppercase border-b border-r border-gray-200">
                E-mail
              </p>
            </div>
            <div>
              <p className="px-3 py-2 text-xs font-bold uppercase border-b border-r border-gray-200">
                Phone
              </p>
            </div>
            <div>
              <p className="px-3 py-2 text-xs font-bold uppercase border-b border-gray-200 ">
                Active
              </p>
            </div>
            <div className="border-b border-gray-200"></div>
          </div>
          {Array.isArray(users) &&
            users.map((user) => {
              return <User key={user.ID} user={user} />;
            })}
        </div>
      )}
      <p className="flex flex-wrap items-center gap-3 mt-10">
        <span className="text-sm font-bold text-gray-400">ROLES:</span>
        <span className="px-2 py-0.5 text-[9px]  uppercase rounded-md bg-green-200">
          Editor
        </span>
        <span className="px-2 py-0.5 text-[9px]  uppercase rounded-md bg-blue-200">
          Sales
        </span>
        <span className="px-2 py-0.5 text-[9px]  uppercase rounded-md bg-purple-200">
          Press
        </span>
        <span className="px-2 py-0.5 text-[9px]  uppercase rounded-md bg-amber-200">
          Dealer - Indoor
        </span>
        <span className="px-2 py-0.5 text-[9px]  uppercase rounded-md bg-amber-400">
          Dealer - Outdoor
        </span>
        <span className="px-2 py-0.5 text-[9px]  uppercase rounded-md bg-amber-600">
          Dealer - Decoration
        </span>
      </p>
    </div>
  );
};
export default UserList;
